// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1___a58eedc9d5a13d48506","cls2":"ContentFeedback-cls2___2db708ef8f1db7055fe ContentFeedback-cls1___a58eedc9d5a13d48506"};